(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flair-49-pro-features"] && !Shopify.designMode) return;
  try {
    
(function() {
  var targets = document.querySelectorAll('[data-fl-observe]');
  if (!targets.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  targets.forEach(function(el) { observer.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flair-49-pro-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var stages = document.querySelectorAll('.fl-gallery__stage, .fl-gallery__stage-m');
    if (!stages.length) return;
    if (!('IntersectionObserver' in window)) {
      stages.forEach(function(s) { s.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
          var stage = entry.target;
          setTimeout(function() {
            var main = stage.querySelector('.fl-gallery__img--main, .fl-gallery__img-m--main');
            if (main) main.classList.add('is-floating');
          }, 3300);
          setTimeout(function() {
            var logoPC = stage.querySelector('.fl-gallery__logo--pc');
            var logoMB = stage.querySelector('.fl-gallery__logo--mb');
            if (logoPC) logoPC.classList.add('is-logo-visible');
            if (logoMB) logoMB.classList.add('is-logo-visible');
          }, 3900);
        }
      });
    }, { threshold: 0.1 });
    stages.forEach(function(s) { observer.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flair-49-pro-richtext"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var CHAR_EFFECTS  = ['char_fade','char_drop','scramble','typewriter','wave'];
  var WORD_EFFECTS  = ['word_fade'];
  var LOOP_EFFECTS  = ['pulse','float','shimmer_loop'];
  var COLOR_EFFECTS = ['color_left','color_right','color_center'];
  var SCRAMBLE_POOL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*';

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function splitChars(el) {
    if (el.dataset.effectReady === 'true') {
      return Array.prototype.slice.call(el.querySelectorAll('.fl-rt__char'));
    }
    el.dataset.effectReady = 'true';
    var text = el.textContent;
    el.textContent = '';
    return text.split('').map(function (ch) {
      var s = document.createElement('span');
      s.className = 'fl-rt__char';
      s.dataset.char = ch;
      s.textContent = ch;
      el.appendChild(s);
      return s;
    });
  }

  function splitWords(el) {
    if (el.dataset.effectReady === 'true') {
      return Array.prototype.slice.call(el.querySelectorAll('.fl-rt__word'));
    }
    el.dataset.effectReady = 'true';
    var words = el.textContent.split(' ');
    el.textContent = '';
    return words.map(function (w, i) {
      var s = document.createElement('span');
      s.className = 'fl-rt__word';
      s.textContent = i < words.length - 1 ? w + ' ' : w;
      el.appendChild(s);
      return s;
    });
  }

  function scrambleEffect(spans, duration, delay) {
    var stagger = 2;
    spans.forEach(function (span, i) {
      var target     = span.dataset.char;
      var startFrame = Math.floor(delay * 60) + i * stagger;
      var endFrame   = startFrame + 15;
      var frame      = 0;
      (function tick() {
        frame++;
        if (frame < startFrame) { requestAnimationFrame(tick); return; }
        if (frame >= endFrame)  { span.textContent = target; return; }
        span.textContent = SCRAMBLE_POOL[rand(0, SCRAMBLE_POOL.length - 1)];
        requestAnimationFrame(tick);
      })();
    });
  }

  function typewriterEffect(spans, duration, delay) {
    var perChar = duration * 1000 / Math.max(spans.length, 1);
    spans.forEach(function (span, i) {
      span.style.opacity = '0';
      setTimeout(function () {
        span.style.transition = 'opacity 0.05s';
        span.style.opacity = '1';
      }, delay * 1000 + i * perChar);
    });
  }

  function injectKeyframes() {
    if (document.getElementById('fl-rt-keyframes')) return;
    var s = document.createElement('style');
    s.id = 'fl-rt-keyframes';
    s.textContent =
      '@keyframes fl-rt-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.04)}}' +
      '@keyframes fl-rt-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}' +
      '@keyframes fl-rt-shimmer{0%{background-position:200% center}100%{background-position:-200% center}}' +
      '@keyframes fl-rt-flash{0%{opacity:1}25%{opacity:.2}50%{opacity:1}75%{opacity:.5}100%{opacity:1}}';
    document.head.appendChild(s);
  }

  function initSection(section) {
    var effect   = section.dataset.effect   || 'none';
    var duration = parseFloat(section.dataset.duration) || 0.8;
    var delay    = parseFloat(section.dataset.delay)    || 0;
    var easing   = section.dataset.easing   || 'ease';
    var cFrom    = section.dataset.colorFrom;
    var cTo      = section.dataset.colorTo;
    var isMobile = window.innerWidth < 750;
    var textEl   = section.querySelector(isMobile ? '.fl-richtext__mobile' : '.fl-richtext__pc');
    if (!textEl) textEl = section.querySelector('.fl-rt__text');
    if (!textEl) return;

    var dur = duration + 's';
    var del = delay    + 's';

    // ── ループ系（Observer不要）
    if (LOOP_EFFECTS.indexOf(effect) > -1) {
      if (effect === 'pulse') {
        textEl.style.animation = 'fl-rt-pulse ' + dur + ' ease infinite';
      } else if (effect === 'float') {
        textEl.style.animation = 'fl-rt-float ' + dur + ' ease-in-out infinite';
      } else if (effect === 'shimmer_loop') {
        textEl.style.backgroundImage = 'linear-gradient(90deg,' + cFrom + ' 25%,' + cTo + ' 50%,' + cFrom + ' 75%)';
        textEl.style.backgroundSize  = '200% auto';
        textEl.style.webkitBackgroundClip = 'text';
        textEl.style.backgroundClip       = 'text';
        textEl.style.webkitTextFillColor  = 'transparent';
        textEl.style.animation = 'fl-rt-shimmer ' + dur + ' linear infinite';
      }
      return;
    }

    if (effect === 'none') return;

    // ── 文字/単語分割
    var spans = [];
    if (CHAR_EFFECTS.indexOf(effect) > -1) spans = splitChars(textEl);
    if (WORD_EFFECTS.indexOf(effect) > -1) spans = splitWords(textEl);

    // ── 初期状態セット
    function setInitial() {
      switch (effect) {
        case 'fade_in':
          textEl.style.opacity = '0'; break;
        case 'fade_top':
          textEl.style.opacity = '0'; textEl.style.transform = 'translateY(-30px)'; break;
        case 'fade_bottom':
          textEl.style.opacity = '0'; textEl.style.transform = 'translateY(30px)'; break;
        case 'fade_left':
          textEl.style.opacity = '0'; textEl.style.transform = 'translateX(-30px)'; break;
        case 'fade_right':
          textEl.style.opacity = '0'; textEl.style.transform = 'translateX(30px)'; break;
        case 'zoom_in':
          textEl.style.opacity = '0'; textEl.style.transform = 'scale(0.7)'; break;
        case 'zoom_out':
          textEl.style.opacity = '0'; textEl.style.transform = 'scale(1.3)'; break;
        case 'rotate_in':
          textEl.style.opacity = '0'; textEl.style.transform = 'rotate(-15deg) scale(0.8)'; break;
        case 'blur_in':
          textEl.style.opacity = '0'; textEl.style.filter = 'blur(12px)'; break;
        case 'bounce':
          textEl.style.opacity = '0'; textEl.style.transform = 'translateY(-60px)'; break;
        case 'elastic':
          textEl.style.opacity = '0'; textEl.style.transform = 'scale(0.3)'; break;
        case 'drop_bounce':
          textEl.style.opacity = '0'; textEl.style.transform = 'translateY(-80px)'; break;
        case 'color_left':
          textEl.style.backgroundImage    = 'linear-gradient(' + cFrom + ',' + cFrom + ')';
          textEl.style.backgroundSize     = '0% 100%';
          textEl.style.backgroundRepeat   = 'no-repeat';
          textEl.style.backgroundPosition = 'left center';
          textEl.style.webkitBackgroundClip = 'text';
          textEl.style.backgroundClip       = 'text';
          textEl.style.webkitTextFillColor  = 'transparent';
          break;
        case 'color_right':
          textEl.style.backgroundImage    = 'linear-gradient(' + cFrom + ',' + cFrom + ')';
          textEl.style.backgroundSize     = '0% 100%';
          textEl.style.backgroundRepeat   = 'no-repeat';
          textEl.style.backgroundPosition = 'right center';
          textEl.style.webkitBackgroundClip = 'text';
          textEl.style.backgroundClip       = 'text';
          textEl.style.webkitTextFillColor  = 'transparent';
          break;
        case 'color_center':
          textEl.style.backgroundImage    = 'linear-gradient(' + cFrom + ',' + cFrom + ')';
          textEl.style.backgroundSize     = '0% 100%';
          textEl.style.backgroundRepeat   = 'no-repeat';
          textEl.style.backgroundPosition = 'center center';
          textEl.style.webkitBackgroundClip = 'text';
          textEl.style.backgroundClip       = 'text';
          textEl.style.webkitTextFillColor  = 'transparent';
          break;
        case 'shimmer':
          textEl.style.backgroundImage   = 'linear-gradient(90deg,' + cFrom + ' 25%,' + cTo + ' 50%,' + cFrom + ' 75%)';
          textEl.style.backgroundSize    = '200% auto';
          textEl.style.backgroundPosition = '200% center';
          textEl.style.webkitBackgroundClip = 'text';
          textEl.style.backgroundClip       = 'text';
          textEl.style.webkitTextFillColor  = 'transparent';
          break;
        case 'color_flash':
          textEl.style.opacity = '0'; break;
        case 'char_fade':
        case 'word_fade':
          spans.forEach(function (s) { s.style.opacity = '0'; }); break;
        case 'char_drop':
          spans.forEach(function (s) {
            s.style.opacity   = '0';
            s.style.transform = 'translateY(-20px)';
          }); break;
        case 'wave':
          spans.forEach(function (s) {
            s.style.opacity   = '0';
            s.style.transform = 'translateY(10px)';
          }); break;
        case 'scramble':
        case 'typewriter':
          break;
      }
    }

    // ── アニメーション起動
    function trigger() {
      var base = 'opacity ' + dur + ' ' + easing + ' ' + del;
      var move = 'transform ' + dur + ' ' + easing + ' ' + del;

      switch (effect) {
        case 'fade_in':
          textEl.style.transition = base;
          textEl.style.opacity = '1'; break;
        case 'fade_top': case 'fade_bottom': case 'fade_left': case 'fade_right':
        case 'bounce': case 'elastic':
          textEl.style.transition = base + ',' + move;
          textEl.style.opacity = '1'; textEl.style.transform = 'none'; break;
        case 'zoom_in': case 'zoom_out':
          textEl.style.transition = base + ',' + move;
          textEl.style.opacity = '1'; textEl.style.transform = 'scale(1)'; break;
        case 'rotate_in':
          textEl.style.transition = base + ',' + move;
          textEl.style.opacity = '1'; textEl.style.transform = 'rotate(0deg) scale(1)'; break;
        case 'blur_in':
          textEl.style.transition = base + ',filter ' + dur + ' ' + easing + ' ' + del;
          textEl.style.opacity = '1'; textEl.style.filter = 'blur(0)'; break;
        case 'drop_bounce':
          textEl.style.transition = base + ',transform ' + dur + ' cubic-bezier(0.34,1.56,0.64,1) ' + del;
          textEl.style.opacity = '1'; textEl.style.transform = 'translateY(0)'; break;
        case 'color_left': case 'color_right': case 'color_center':
          textEl.style.transition = 'background-size ' + dur + ' ' + easing + ' ' + del;
          textEl.style.backgroundSize = '100% 100%'; break;
        case 'shimmer':
          textEl.style.transition = 'background-position ' + dur + ' linear ' + del;
          textEl.style.backgroundPosition = '-200% center'; break;
        case 'color_flash':
          textEl.style.opacity = '1';
          textEl.style.animation = 'fl-rt-flash ' + dur + ' ' + easing + ' ' + del + ' forwards'; break;
        case 'char_fade':
        case 'word_fade':
          spans.forEach(function (s, i) {
            var sd = (delay + i * 0.05) + 's';
            s.style.transition = 'opacity ' + dur + ' ' + easing + ' ' + sd;
            s.style.opacity = '1';
          }); break;
        case 'char_drop':
          spans.forEach(function (s, i) {
            var sd = (delay + i * 0.04) + 's';
            s.style.transition = 'opacity ' + dur + ' ' + easing + ' ' + sd + ',transform ' + dur + ' ' + easing + ' ' + sd;
            s.style.opacity = '1'; s.style.transform = 'translateY(0)';
          }); break;
        case 'scramble':
          scrambleEffect(spans, duration, delay); break;
        case 'typewriter':
          typewriterEffect(spans, duration, delay); break;
        case 'wave':
          spans.forEach(function (s, i) {
            var sd = (delay + i * 0.06) + 's';
            s.style.transition = 'opacity ' + dur + ' ' + easing + ' ' + sd + ',transform ' + dur + ' ' + easing + ' ' + sd;
            s.style.opacity = '1'; s.style.transform = 'translateY(0)';
          }); break;
      }
    }

    setInitial();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(section);
          trigger();
        }
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  }

  injectKeyframes();
  document.querySelectorAll('.fl-rt').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flair-49-pro"]) return;
  try {
    
(function () {
  'use strict';

  /* ── Hero video: inject src into the displayed side only ── */
  /* Both hero sections stay in the DOM, so a hard-coded src makes the hidden
     side download too. Breakpoint must match the display switch (<=768px = mobile). */
  var heroMobileMq = window.matchMedia('(max-width: 768px)');

  function loadHeroVideo() {
    var video = document.querySelector(
      heroMobileMq.matches ? '.fl-hero__video-m' : '.fl-hero__video'
    );
    if (!video || video.dataset.srcInjected === 'true') return;

    var src = video.getAttribute('data-src');
    if (!src) return;

    var source = document.createElement('source');
    source.setAttribute('src', src);
    source.setAttribute('type', 'video/mp4');
    video.appendChild(source);
    video.dataset.srcInjected = 'true';
    video.load();

    video.classList.add('is-active');
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  loadHeroVideo();

  if (heroMobileMq.addEventListener) {
    heroMobileMq.addEventListener('change', loadHeroVideo);
  } else if (heroMobileMq.addListener) {
    heroMobileMq.addListener(loadHeroVideo);
  }

  /* ── Hero copy fade-in (immediate trigger) ── */
  var heroFadeTargets = document.querySelectorAll(
    '.fl-hero--desktop .fl-hero__headline, .fl-hero--desktop .fl-hero__body, .fl-hero--mobile .fl-hero__headline-m, .fl-hero--mobile .fl-hero__body-m'
  );

  if (heroFadeTargets.length) {
    var heroFadeFired = false;

    function fireHeroFade() {
      if (heroFadeFired) return;
      if (window.scrollY > 5) {
        heroFadeTargets.forEach(function (el) {
          el.classList.add('is-visible');
        });
        heroFadeFired = true;
        window.removeEventListener('scroll', fireHeroFade);
      }
    }

    window.addEventListener('scroll', fireHeroFade, { passive: true });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
